import { useEffect } from "react";
import PageContainer from "@components/layout/PageContainer";
import ExpenseYearReportForm from "@components/dynamic/ExpenseYearReportForm ";

const ExpenseByYearReport = () => {
  useEffect(() => {
  }, []);


  return (
    <PageContainer
      title="Reporte de Gastos por año"
      backUrl="/user/dashboard-accounting"
    >
      <ExpenseYearReportForm />
    </PageContainer >
  );
}

export default ExpenseByYearReport;
